/**
 * @observable
 * Created by neo on 01.06.17.
 */

import {observable} from 'mobx';

export default class Payment {
  @observable id: string;
  @observable name: string;
  @observable token: string;

  constructor(json?: any) {
    if(json) {
      this.id = json.id;
      this.name = json.name;
      this.title = json.title;
      this.token = json.token;

      this.currency = json.currency;
      this.fee_fixed = json.fee_fixed || 0;
      this.fee_percent = json.fee_percent || 0;
      this.stripe_public_key = json.stripe_public_key || 0;
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/Payment.js